import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import feedbackFormStyle from "./feedbackFormStyle";
import ClientAgrees from "./Modules/ClientAgrees";
import LawsuitConsequences from "./Modules/LawsuitConsequences";
import FinalProcessFeedbackClient from "./Modules/FinalProcessFeedbackClient";
import { useForm } from "@/src/provider/Form/FormProvider";
import AdditionalFeedbackMessage from "./Modules/AdditionalFeedbackMessage";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";
import Recommendation from "./Modules/Recommendation";

type FeedbackFormProps = {
  product: AbstractCase;
  isLoading: boolean;
};

const FeedbackForm = ({ product, isLoading }: FeedbackFormProps) => {
  const { handleSubmit, values, updateValue } = useForm();
  const [hasClaimStatusClient, setHasClaimStatusClient] = useState(false);

  const { extrajudicialReaction } = product;
  const { clientAgrees, reactionReceived } = values;
  useEffect(() => {
    setHasClaimStatusClient(
      !((extrajudicialReaction === "fullyAgreed" && clientAgrees !== "no") || (extrajudicialReaction === "noReaction" && reactionReceived !== "yes"))
    );
  }, [setHasClaimStatusClient, extrajudicialReaction, clientAgrees, reactionReceived]);

  useEffect(() => {
    updateValue("finalClaimStatusClient", clientAgrees === "no" || extrajudicialReaction !== "fullyAgreed" ? "notAgreed" : "fullyAgreed");
  }, [clientAgrees, extrajudicialReaction]);

  return (
    <Paper sx={feedbackFormStyle.paper} elevation={4}>
      <Box component={"form"} sx={{ ...feedbackFormStyle.applicationForm, ...feedbackFormStyle.wizardForm }} onSubmit={handleSubmit}>
        <Grid
          container
          sx={{
            justifyContent: "flex-start",
            alignItems: "baseline"
          }}>
          <ClientAgrees
            product={product}
            question={"Ist die Reaktion der Haftpflichtversicherung Ihres Unfallgegners für Sie zufriedenstellend?"}
            hintText={
              "Hier geht es zunächst nur darum, dass die Reaktion der Haftpflichtversicherung Ihres Unfallgegners in Ihrem Sinne ist. Sollten noch Einzelheiten zur vollständigen Abwicklung des Falls zwischen Ihnen und der Gegenseite geklärt werden müssen, können Sie dies natürlich noch im Nachgang tun."
            }
          />
          <Recommendation product={product} hasClaimStatusClient={hasClaimStatusClient} />
          <FinalProcessFeedbackClient
            product={product}
            hasClaimStatusClient={hasClaimStatusClient}
            enforceClaimHintText={
              "Ich akzeptiere die Reaktion der gegnerischen Haftpflichtversicherung nicht und möchte die Schadensregulierung per Klage im gerichtlichen Verfahren durchsetzen."
            }
          />
          <LawsuitConsequences product={product} />
          <AdditionalFeedbackMessage />
        </Grid>
        <ButtonLoading sx={feedbackFormStyle.button} fullWidth variant="contained" color="primary" type="submit" isLoading={isLoading}>
          Meine Rückmeldung übermitteln
        </ButtonLoading>
      </Box>
    </Paper>
  );
};
export default FeedbackForm;
